module.exports = __webpack_public_path__ + "img/diagnostico_gris.ec9d01c3.svg";